import { Moment } from 'moment';
import { DateTimeUtilsService } from '../../services/date-time-utils-service.service';
import { LeaveImportTemplate } from './template.model';

export class LeaveImportModel {
    fechaAviso: string;

    constructor(
        fechaAviso: Moment,
        public empresaID: number,
        public templateData: LeaveImportTemplate,
        public excelFile: string,
    ) {
        const util = new DateTimeUtilsService();
        this.fechaAviso = util.convertMomentFormBackend(fechaAviso);
    }
}